var React = require('react');

function VolumeMute (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M84 20L60 44M60 20L84 44M40 4L20 20H4V44H20L40 60V4Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

VolumeMute.defaultProps = {"width":"88","height":"64","viewBox":"0 0 88 64","fill":"none"};

module.exports = VolumeMute;

VolumeMute.default = VolumeMute;
